type OpenGraphEntry = {
  attribute: {
    key: string;
    value: string;
  };
  content: string;
};

type FeaturedImage = {
  image: {
    value: { url: string }[];
  };
};

type MetaImage = {
  elements: {
    image: {
      value: { url: string }[];
    };
  };
};

export type ShareImages = {
  featured: FeaturedImage | null;
  meta: MetaImage[] | null;
};

type OpenGraphArgs = {
  title: string;
  url: string;
  description: string;
  shareImages: ShareImages;
};

const openGraphImages = (shareImages: OpenGraphArgs["shareImages"]) => {
  const images = [];
  const hasMetaImages = shareImages?.meta && shareImages.meta.length;
  const hasFeatured =
    shareImages?.featured && shareImages.featured.image?.value.length;

  if (hasMetaImages) {
    shareImages.meta.forEach((image) => {
      images.push({
        attribute: {
          key: "property",
          value: "og:image"
        },
        content: image.elements.image.value[0].url
      });
    });
  }

  if (!images.length && hasFeatured) {
    images.push({
      attribute: {
        key: "property",
        value: "og:image"
      },
      content: shareImages.featured.image.value[0].url
    });
  }

  return images;
};

const metaOpenGraph = ({
  title,
  url,
  description,
  shareImages
}: OpenGraphArgs): OpenGraphEntry[] => {
  const entries = [
    {
      attribute: {
        key: "property",
        value: "og:type"
      },
      content: "website"
    },
    {
      attribute: {
        key: "property",
        value: "og:url"
      },
      content: url
    },
    {
      attribute: {
        key: "property",
        value: "og:title"
      },
      content: title
    },
    {
      attribute: {
        key: "property",
        value: "og:description"
      },
      content: description
    }
  ];

  return entries
    .concat(openGraphImages(shareImages))
    .filter((entry) => entry.content);
};

export default metaOpenGraph;
